import {useTranslation} from '@aboutyou/i18n';

export const useGetAriaLabelFromUrl = () => {
  const {t} = useTranslation();
  return (url: string) => {
    switch (true) {
      case url === '/hub/streetwear':
        return t('Go to the streetwear page');
      case url === '/hub/sportswear':
        return t('Go to the sportswear page');
      case /\/p\/.+quick=view.*/.test(url):
        return t('Go to the article detail page quick view');
      case /\/p\/.+/.test(url):
        return t('Go to the article detail page');
      case /\/c\/.+/.test(url):
        return t('Go to the category page');
      case /\/d\/.+\/overview/.test(url):
        return t('Go to the drops overview page');
      case /\/d\/.+/.test(url):
        return t('Go to the drops details page');
      case /\/cp\/.+/.test(url):
        return t('Go to the custom page');
      case /\/s\/.+/.test(url):
        return t('Go to the story page');
      case /\/about\/brand\/.+/.test(url):
      case /\/b\/shop\/.+/.test(url):
      case /brand=/.test(url):
        return t('Go to the brand page');
      case /\/b\/discover\/.+/.test(url):
        return t('Go to the brand discover page');
      case /\/o\/.+/.test(url):
        return t('Go to the outfit page');
      case /\/l\/.+/.test(url):
        return t('Go to the live shopping page');
      case url === '':
        return t('Go to the browse page');
      default:
        return t('Go to the link');
    }
  };
};
